import { createActions, createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';

export const INITIAL_STATE = Immutable({
  data: [],
  loaded: false,
  loading: false,

  pnh: {
    districts: {},
    loading: false,
  },

  rep: {
    districts: {},
    loading: false
  }
});

const { Types, Creators } = createActions({
  getRegions: null,
  setRegions: ['data'],

  getDistricts: ['payload'],
  setDistricts: ['payload']
});

export const getRegionsReducer = state => state.set('loading', true)

export const setRegionsReducer = (state, { data }) =>
  state
    .set('data', data)
    .set('loaded', true)
    .set('loading', false)

export const getDistrictsReducer = (state, { payload }) =>
  state.setIn([payload.region, 'loading'], true)

export const setDistrictsReducer = (state, { payload }) =>
  state
    .setIn([payload.region, 'loading'], false)
    .setIn([payload.region, 'districts'], payload.data)

export const regionReducer = createReducer(INITIAL_STATE, {
  [Types.GET_REGIONS]: getRegionsReducer,
  [Types.SET_REGIONS]: setRegionsReducer,

  [Types.SET_DISTRICTS]: setDistrictsReducer,
})


export const RegionTypes = Types
export default Creators;


// WEBPACK FOOTER //
// ./src/reducers/regionReducer.js